// import React, { useState } from "react";
// import { useForm, Controller } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";

// const schema = yup.object({
//     role: yup.string().required(),
//     mobile: yup
//         .string()
//         .required("Mobile number is required")
//         .matches(/^\d{10}$/, "Mobile number must be 10 digits"),
//     firstName: yup.string().required("First name is required"),
//     lastName: yup.string().required("Last name is required"),
//     email: yup.string().email("Invalid email").required("Email is required"),
// });

// export default function SignupPage() {
//     const navigate = useNavigate();

//     const [otp, setOtp] = useState(Array(6).fill(""));
//     const [otpRequested, setOtpRequested] = useState(false);

//     const {
//         control,
//         handleSubmit,
//         watch,
//         setValue,
//         formState: { errors },
//     } = useForm({
//         resolver: yupResolver(schema),
//         defaultValues: {
//             role: "employer",
//             mobile: "",
//             firstName: "",
//             lastName: "",
//             email: "",
//         },
//     });

//     const mobile = watch("mobile");

//     const handleRequestOtp = () => {
//         if (mobile.match(/^\d{10}$/)) {
//             setOtpRequested(true);
//             alert("OTP sent to +91" + mobile);
//         } else {
//             alert("Please enter a valid 10-digit mobile number");
//         }
//     };

//     const handleOtpChange = (index: any, value: any) => {
//         const newOtp = [...otp];
//         newOtp[index] = value.replace(/[^0-9]/g, "").slice(0, 1);
//         setOtp(newOtp);
//     };

//     const onSubmit = (data: any) => {
//         if (otp.every((d) => d !== "")) {
//             alert(`Sign up confirmed for ${data.firstName} ${data.lastName}`);
//         } else {
//             alert("Please enter the complete OTP");
//         }
//     };

//     return (
//         <motion.div className="min-h-screen flex items-center justify-center bg-white p-4">
//             <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
//                 <div className="text-sm text-purple-600 mb-4 cursor-pointer"
//                     onClick={() => navigate("/login")}
//                 >
//                     Back to Login
//                 </div>
//                 <h1 className="text-3xl font-bold text-center mb-6">Wizkind</h1>

//                 <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
//                     <div>
//                         <label className="block font-medium mb-1">Signup as</label>
//                         <div className="flex gap-4">
//                             <label className="flex items-center gap-2">
//                                 <Controller
//                                     name="role"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <input {...field} type="radio" value="employee" checked={field.value === "employee"} />
//                                     )}
//                                 />
//                                 Employee
//                             </label>
//                             <label className="flex items-center gap-2">
//                                 <Controller
//                                     name="role"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <input {...field} type="radio" value="employer" checked={field.value === "employer"} />
//                                     )}
//                                 />
//                                 Employer
//                             </label>
//                         </div>
//                     </div>

//                     <div>
//                         <label className="block font-medium mb-1">Mobile Number</label>
//                         <div className="flex items-center gap-2">
//                             <span className="border px-3 py-2 rounded">+91</span>
//                             <Controller
//                                 name="mobile"
//                                 control={control}
//                                 render={({ field }) => (
//                                     <input {...field} type="text" maxLength={10} className="w-full border rounded px-3 py-2" placeholder="1234567890" />
//                                 )}
//                             />
//                         </div>
//                         {errors.mobile && <p className="text-red-500 text-sm mt-1">{errors.mobile.message}</p>}
//                     </div>

//                     <button
//                         type="button"
//                         onClick={handleRequestOtp}
//                         className="w-full bg-purple-600 text-white py-2 rounded mt-2"
//                     >
//                         Request One Time Passcode
//                     </button>

//                     {otpRequested && (
//                         <div className="space-y-2">
//                             <p>Please enter a valid 6-digit One Time Passcode you received on SMS</p>
//                             <div className="flex gap-2">
//                                 {otp.map((digit, idx) => (
//                                     <input
//                                         key={idx}
//                                         type="text"
//                                         maxLength={1}
//                                         className="w-10 text-center border rounded"
//                                         value={digit}
//                                         onChange={(e) => handleOtpChange(idx, e.target.value)}
//                                     />
//                                 ))}
//                             </div>
//                             <p className="text-sm">
//                                 Didn't get the code?{' '}
//                                 <button
//                                     type="button"
//                                     className="text-purple-600 underline"
//                                     onClick={handleRequestOtp}
//                                 >
//                                     Resend One Time Passcode
//                                 </button>
//                             </p>
//                         </div>
//                     )}

//                     <Controller
//                         name="firstName"
//                         control={control}
//                         render={({ field }) => (
//                             <input {...field} placeholder="First Name*" className="w-full border rounded px-3 py-2" />
//                         )}
//                     />
//                     {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName.message}</p>}

//                     <Controller
//                         name="lastName"
//                         control={control}
//                         render={({ field }) => (
//                             <input {...field} placeholder="Last Name*" className="w-full border rounded px-3 py-2" />
//                         )}
//                     />
//                     {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName.message}</p>}

//                     <Controller
//                         name="email"
//                         control={control}
//                         render={({ field }) => (
//                             <input {...field} placeholder="Email*" className="w-full border rounded px-3 py-2" />
//                         )}
//                     />
//                     {errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}

//                     <button type="submit" className="w-full bg-purple-600 text-white py-2 rounded">
//                         Confirm
//                     </button>
//                 </form>

//                 <div className="text-center pt-4">
//                     <p>Already Have an Account?</p>
//                     <button className="w-full border mt-2 py-2 rounded">Login</button>
//                 </div>

//                 <div className="text-center text-sm text-gray-500 pt-4">
//                     <a href="/terms" className="mr-4 underline">Terms and conditions</a>
//                     <a href="/privacy" className="underline">Privacy policy</a>
//                 </div>
//             </div>
//         </motion.div>
//     );
// }

import { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../components/common/Input";
import Button from "../../components/common/Button";
import OTPInput from "../../components/common/OTPInput";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import InputsNew from "../../components/common/InputsNew";

const EyeIcon = Eye;
const EyeOffIcon = EyeOff;


const mobileSchema = yup.object().shape({
    phone: yup.string().required("Phone is required").matches(/^[0-9]{10}$/, "Enter a valid 10-digit number"),
});

const passwordRules = /^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{9,}$/;

const userSchema = yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup.string().email().required(),
    password: yup
        .string()
        .matches(
            passwordRules,
            "Password must contain more than 8 characters | 1 numeric | 1 upper case letter | and 1 special character($@$!%*?&)"
        )
        .required("Password is required"),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref("password")], "Password you have entered does not match.")
        .required("Confirm Password is required"),
});

type MobileFormData = { phone: string };
type UserFormData = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
};

const Signup = () => {
    const { login } = useAuth();
    const [step, setStep] = useState<"MOBILE" | "MOBILE_OTP" | "DETAILS" | "EMAIL_OTP">("MOBILE");
    const [mobileOTP, setMobileOTP] = useState("");
    const [emailOTP, setEmailOTP] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // const { login } = useAuth();
    const navigate = useNavigate();

    const {
        register: registerMobile,
        handleSubmit: handleSubmitMobile,
        formState: { errors: mobileErrors },
    } = useForm<MobileFormData>({ resolver: yupResolver(mobileSchema) });

    const {
        register: registerUser,
        handleSubmit: handleSubmitUser,
        formState: { errors: userErrors },
    } = useForm<UserFormData>({ resolver: yupResolver(userSchema) });

    const handleMobileSubmit = (data: any) => {
        console.log("Send mobile OTP to", data.phone);
        setStep("MOBILE_OTP");
    };

    const handleUserSubmit = (data: UserFormData) => {
        console.log("Send email OTP to", data.email);
        setStep("EMAIL_OTP");
    };

    const handleFinalConfirm = () => {
        console.log("Verifying email OTP:", emailOTP);
        const userData = {
            email: "email-from-api",
            id: "user-id-from-api",
            access_type: "Assessor" // Or whatever logic you apply
        };

        login(userData);
        navigate("/dashboard");
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
            <div className="bg-white shadow-md p-6 rounded max-w-md w-full text-center">
                <img src="/logo.svg" alt="Logo" className="mx-auto mb-4" />
                <h2 className="text-xl font-bold mb-4">Signup as</h2>

                {step === "MOBILE" && (
                    <form onSubmit={handleSubmitMobile(handleMobileSubmit)}>
                        <div className="flex items-center gap-2 mb-4">
                            <span>🇮🇳 +91</span>
                            <Input placeholder="1234567890" {...registerMobile("phone")} error={mobileErrors.phone} />
                        </div>
                        <Button title="Request One Time Passcode" type="submit" />
                    </form>
                )}

                {step === "MOBILE_OTP" && (
                    <>
                        <p className="text-sm my-4">Enter the OTP sent to your mobile</p>
                        <OTPInput onChange={setMobileOTP} />
                        <Button title="Confirm" onClick={() => setStep("DETAILS")} className="mt-4" />
                    </>
                )}

                {step === "DETAILS" && (
                    <form onSubmit={handleSubmitUser(handleUserSubmit)}>
                        <div className="grid grid-cols-2 gap-2">
                            <InputsNew
                                type="text"
                                label="First Name"
                                register={registerUser("firstName")}
                                errorMessage={userErrors.firstName}
                            />
                            <InputsNew
                                type="text"
                                label="Last Name"
                                register={registerUser("lastName")}
                                errorMessage={userErrors.lastName}
                            />
                        </div>
                        <InputsNew
                            type="text"
                            label="Email"
                            register={registerUser("email")}
                            errorMessage={userErrors.email}
                        />
                        <div className="relative">
                            <InputsNew
                                type={showPassword ? "text" : "password"}
                                register={registerUser("password")}
                                contentPlaceholder="Password"
                                className="w-full border rounded px-3 py-2"
                            />
                            <span
                                onClick={() => setShowPassword((prev) => !prev)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                            >
                                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                            </span>
                            {userErrors.password && (
                                <p className="text-red-500 text-sm">{userErrors.password.message}</p>
                            )}
                        </div>
                        <div className="relative">
                            <InputsNew
                                type={showConfirmPassword ? "text" : "password"}
                                register={registerUser("confirmPassword")}
                                contentPlaceholder="Confirm Password"
                                className="w-full border rounded px-3 py-2"
                            />
                            <span
                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                            >
                                {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                            </span>
                            {userErrors.confirmPassword && (
                                <p className="text-red-500 text-sm">{userErrors.confirmPassword.message}</p>
                            )}
                        </div>


                        {/* <Input label="Password" type="password" {...registerUser("password")} error={userErrors.password} />
                        <Input label="Confirm Password" type="password" {...registerUser("confirmPassword")} error={userErrors.confirmPassword} /> */}
                        <Button title="Verify Email" type="submit" />
                    </form>
                )}

                {step === "EMAIL_OTP" && (
                    <>
                        <p className="text-sm my-4">Enter the email OTP</p>
                        <OTPInput onChange={setEmailOTP} />
                        <Button title="Confirm" onClick={handleFinalConfirm} className="mt-4" />
                    </>
                )}

                <div className="mt-6">
                    <p className="text-sm">Already have an account?</p>
                    <Button title="Login" variant="secondary" onClick={() => navigate("/login")} />
                </div>

                <div className="text-xs mt-4 text-gray-400 space-x-2">
                    <a href="#">Terms and conditions</a>
                    <a href="#">Privacy policy</a>
                </div>
            </div>
        </div>
    );
};

export default Signup;

